import { Navigate } from "react-router-dom";

import React from "react";
import { useStudyPlan } from "../../../../app/contexts/study.context";

export default function EditRoute({ children }) {
  const { canEditPlan, studyPlan } = useStudyPlan();
  const { studyPlanId, studyId } = studyPlan;

  if (!canEditPlan) {
    return (
      <Navigate
        to={`/ctpo/study-plans/${studyId}/${studyPlanId}/review`}
        replace
      />
    );
  }

  return children;
}
